<template>
  <v-card>
    <v-data-table
      v-model="selected"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 20, 50, -1],
      }"
      :headers="headers"
      :hide-default-footer="items.length < 10"
      :items="items"
      :items-per-page="50"
      :search="search"
      :show-select="selectable"
      item-key="name"
    >
      <template #top>
        <v-toolbar class="mb-3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Search in any field"
            single-line
            style="max-width: 20em"
          />

          <v-spacer />

          <v-switch
            v-model="selectable"
            class="mt-5 mr-4"
            label="Select"
          />

          <v-btn-toggle>
            <HeadersDialog
              :available-headers="availableHeaders"
              :headers.sync="headers"
            />
            <DeleteDialog
              v-model="visibleDelete"
              :disabled="!selected.length"
              :items="selected"
              :visible="selectable"
              button-title="mdi-delete"
              :api-url="API_URL"
              object-type="users"
              title="Delete selected users"
              @click="deleteItems(selected)"
              @itemDeleted="removeItems"
            />
            <PasswordDialog
              v-model="visiblePassword"
              :item="item"
              :visible="false"
              max-width="300"
            />
            <UserDialog
              v-model="visibleUser"
              :item="item"
              :disabled="selectable"
              :on-button-activate="resetItem"
              :visible="!selectable"
              button-title="mdi-account-plus"
              max-width="600"
              @userUpdated="onUpdated"
              @userCreated="onCreated"
            />
          </v-btn-toggle>
        </v-toolbar>
      </template>

      <template #[`item.name`]="{ item }">
        <b-link :to="`/users/${item.id}`">{{ item.name }}</b-link>
      </template>

      <template #[`item.dateCreated`]="{ item }">
        {{ dateTimeFormat.format(item.dateCreated) }}
      </template>

      <template #[`item.privileges`]="{ item }">
        <v-chip
          v-for="(privilege, i) in item.privileges"
          :key="i"
          class="mr-1"
          label
          outlined
          small
        >
          {{ privilege }}
        </v-chip>
      </template>

      <template #[`item.groups`]="{ item }">
        <v-chip
          v-for="(group, i) in item.groups"
          :key="i"
          class="mr-1"
          label
          outlined
          small
        >
          {{ group.name }}
        </v-chip>
      </template>

      <template #[`item.roles`]="{ item }">
        <v-chip
          v-for="(role, i) in item.roles"
          :key="i"
          class="mr-1"
          label
          outlined
          small
        >
          {{ role.name }}
        </v-chip>
      </template>

      <template #[`item.active`]="{ item }">
        <v-chip
          small
          :color="item.active ? 'green' : 'red'"
        />
      </template>

      <template #[`item.actions`]="{ item }">
        <div class="justify-end mr-0">
          <v-icon
            :disabled="selectable"
            class="mr-1"
            title="Edit"
            @click="editItem(item)"
          >
            mdi-account-edit
          </v-icon>
          <v-icon
            :disabled="selectable"
            class="mr-1"
            title="Change password"
            @click="editPassword(item)"
          >
            mdi-account-key
          </v-icon>
          <v-icon
            :disabled="selectable"
            title="Delete"
            @click="deleteItems([item])"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import DeleteDialog from '@/components/dialogs/DeleteDialog.vue'
import TableBase from '@/components/TableBase'
import UserDialog from '@/components/auth/UserDialog'
import HeadersDialog from '@/components/dialogs/HeadersDialog.vue'
import { AUTH_URL } from '@/main'
import PasswordDialog from '@/components/auth/PasswordDialog'

export default {
  components: { PasswordDialog, HeadersDialog, UserDialog, DeleteDialog },

  mixins: [TableBase],

  data: () => ({
    allHeaders: [
      { text: 'Username', value: 'name' },
      { text: 'Full Name', value: 'fullName' },
      { text: 'Email', value: 'email' },
      { text: 'Company', value: 'company' },
      { text: 'Privileges', value: 'privileges', sortable: false },
      { text: 'Groups', value: 'groups', sortable: false },
      { text: 'Roles', value: 'roles', sortable: false },
      { text: 'Active', value: 'active' },
      { text: 'Created', value: 'dateCreated', initial: false },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'end',
        fixed: true,
      },
    ],
    editMode: false,
    visibleUser: false,
    visiblePassword: false,
  }),

  computed: {
    API_URL() {
      return `${AUTH_URL}`
    },
    OBJECTS_TYPE() {
      return 'users'
    },
  },

  methods: {
    resetItem() {
      this.item = null
    },
    onUpdated(user) {
      Object.assign(
        this.items.find((u) => u.id === user.id),
        user,
      )
      this.items = [...this.items]
    },
    onCreated(user) {
      this.items = [...this.items, user]
    },
    editItem(user) {
      this.item = user
      this.visibleUser = true
    },
    editPassword(user) {
      this.item = user
      this.visiblePassword = true
    },
  },
}
</script>
